import React, { Component } from 'react';
import update from 'immutability-helper';
import Loading from '../Loading.js'
import FormInput from '../../Fields/FormInput.js'
import NamezzzEduOrg from '../../Fields/NamezzzEduOrg.js';
import NamezzzEdu from '../../Fields/NamezzzEdu.js';
import FormSelect from '../../Fields/FormSelect.js';
import FormCheckbox from '../../Fields/FormCheckbox.js';
import FormList from '../../Fields/FormList.js'
import { getPersonalia, getPersonEducations, postPersonEducations, deletePersonEducations } from '../../Api/UserActions.js'
import { getJsonItem, isEmpty } from '../../Utilities/JsonFunctions.js'
import { getTranslation } from '../../Utilities/GetTranslation.js'
import { getCountries, getResults, getEducationDomain, getEducationNiveau } from '../../Api/Namezzz.js';
import NamezzzCountry from '../../Fields/NamezzzCountry.js';
import { getEducationsFormList } from '../../Utilities/SnsFunctions.js';

declare var globalSns;

class Educations extends Component {
    constructor(props) {
        super(props);

        this.state = {
            inputCountryId: 1,
            popupDomain: false,
            inputOrganisationId: null,
            inputOrganisation: "",
            inputDomain: -1,
            inputNiveau: -1,
            inputDescription: "",
            inputYearGrad: -1,
            inputResult: -1,
            inputHighest: false,
            inputDescriptionId: null,
            inputDescriptionSynonymId: null,
            showValidation: false
        }
        
        this.deleteEducation = this.deleteEducation.bind(this);
        this.editEducation = this.editEducation.bind(this);
        this.addEducation = this.addEducation.bind(this);        
        this.resetEducation = this.resetEducation.bind(this);
        
        this.onCountryChange = this.onCountryChange.bind(this);
        this.onDomainChange = this.onDomainChange.bind(this);
        this.onNiveauChange = this.onNiveauChange.bind(this);
        this.onDescriptionChange = this.onDescriptionChange.bind(this);
        this.onDescriptionBlur = this.onDescriptionBlur.bind(this);
        this.onForeignDescriptionChange = this.onForeignDescriptionChange.bind(this);
        this.onOrganisationChange = this.onOrganisationChange.bind(this);        
        this.onSelectChange = this.onSelectChange.bind(this);
        this.onHighestChange = this.onHighestChange.bind(this);
    }

    componentWillMount() {
        this.loadData();
    }

    loadData() {
        getPersonalia(globalSns.languageId, globalSns.jobId, (data) => {
            this.setState({
                data: data
            });
        });
        getCountries(globalSns.languageId, (data) => {
            this.setState({
                countries: data
            });
        });
        getResults(globalSns.languageId, (data) => {
            this.setState({
                results: data
            });
        });
        getPersonEducations(globalSns.languageId, (data) => {
            this.setState({
                personEducations: data
            });
        });
        getEducationDomain(globalSns.languageId, this.state.inputCountryId, (data) => {
            this.setState({
                educationdomain: data
            })
        });
    }

    async isValidated() {
        if (isEmpty(this.state.inputDescription) && isEmpty(this.state.inputOrganisation) &&
        (!this.state.popupDomain || (this.state.inputDomain === -1 && this.state.inputNiveau === -1)) &&
        this.state.inputYearGrad === -1 && this.state.inputResult === -1) {
            return true;
        }

        // We have to add the current values after navigating to other page
        var valid = this.addEducation();
        return valid;
    }

    // editId: null => add education
    // editId: value => modify education
    addEducation() {
        return new Promise(ok => {
            if (isEmpty(this.state.inputCountryId) || isEmpty(this.state.inputDescription) || isEmpty(this.state.inputOrganisation) ||
            (this.state.popupDomain && (this.state.inputDomain === -1 || this.state.inputNiveau === -1)) ||
            this.state.inputYearGrad === -1 || this.state.inputResult === -1) {
                this.setState({
                    showValidation: true
                })
                ok(false); // no education is added
                return;
            }
    
            var id = this.state.editId;
    
            postPersonEducations(id, this.state.inputOrganisationId, this.state.inputOrganisation,
                this.state.inputCountryId, this.state.inputYearGrad, this.state.inputResult, this.state.inputHighest,
                this.state.inputDescription, this.state.inputDomain, this.state.inputNiveau, this.state.inputDescriptionId, this.state.inputDescriptionSynonymId, (newData) => {
                    
                    ok(true); // education is added

                    var personEducations = this.state.personEducations;
    
                    // Unset highest
                    if (newData.isHighest) {
                        for (var i = 0; i < personEducations.length; i++) {
                            personEducations = update(personEducations, {[i]: {isHighest: {$set: false}}});
                        }                
                    }
        
                    if (newData.id === id) {
                        // Update education
                        var item = getJsonItem(personEducations, "id", id);
                        var index = personEducations.indexOf(item);
                        
                        this.setState({
                            personEducations: update(personEducations, {[index]: {$set: newData}})
                        });
        
                        return;
                    }
        
                    // New education
                    this.setState({
                        personEducations: update(personEducations, {$push: [newData]})
                    });                
            });
    
            this.setState({
                editId: null,
                popupDomain: (this.state.inputCountryId !== 1),
                inputOrganisationId: null,
                inputOrganisation: "",
                inputDescription: "",
                inputYearGrad: -1,
                inputResult: -1,
                inputHighest: false,
                inputDomain: -1,
                inputNiveau: -1,
                inputDescriptionId: null,
                inputDescriptionSynonymId: null,
                showValidation: false
            });
    
            if (this.state.inputCountryId === 1) {
                this.refs.inputEduBelgium.el.focus();
            } else {
                this.refs.inputEduForeign.el.focus();
            }
        });
    }

    deleteEducation(id) {
        deletePersonEducations(id, () => {
            var item = getJsonItem(this.state.personEducations, "id", id);
            var index = this.state.personEducations.indexOf(item);

            this.setState({
                personEducations: update(this.state.personEducations, {$splice: [[index, 1]]})
            })
        });
    }

    editEducation(id) {
        var item = getJsonItem(this.state.personEducations, "id", id);

        if (item == null) {
            return;
        }


        getEducationDomain(globalSns.languageId, item.countryId, (data) => {
            this.setState({
                educationdomain: data
            });
        });
        getEducationNiveau(globalSns.languageId, item.eduDomainId, (data) => {
            this.setState({
                educationniveau: data
            });
        });

        this.setState({
            editId: id,
            popupDomain: (item.eduDescriptionId == null),
            inputCountryId: item.countryId,
            inputOrganisationId: item.seqOrg,
            inputOrganisation: item.org ,       
            inputDescription: item.description,
            inputYearGrad: item.yearGrad,
            inputResult: item.resultId,
            inputHighest: item.isHighest,
            inputDomain: item.eduDomainId,
            inputNiveau: item.eduNiveauId,
            inputDescriptionId: item.eduDescriptionId,
            inputDescriptionSynonymId: item.eduDescriptionSynonymId
        });
    }

    resetEducation(e) {
        this.setState({
            editId: null,
            popupDomain: (this.state.inputCountryId !== 1),
            inputOrganisationId: null,
            inputOrganisation: "",
            inputDescription: "",
            inputYearGrad: -1,
            inputResult: -1,
            inputHighest: false,
            inputDomain: -1,
            inputNiveau: -1,
            inputDescriptionId: null,
            inputDescriptionSynonymId: null
        });

        if (this.state.inputCountryId === 1) {
            this.refs.inputEduBelgium.el.focus();
        } else {
            this.refs.inputEduForeign.el.focus();
        }
    }

    onCountryChange(id) {
        if (this.state.inputCountryId === id) {
            return;
        }

        this.setState({
            popupDomain: (id !== 1),
            inputCountryId: id,
            inputDescription: "",
            inputDescriptionId : null,
            inputDescriptionSynonymId: null,
            inputOrganisationId: null,
            inputOrganisation: "",
            inputDomain: -1,
            inputNiveau: -1,
            educationdomain: null,
            educationniveau: null
        });

        if (id != null) {
            getEducationDomain(globalSns.languageId, id, (data) => {
                this.setState({
                    educationdomain: data
                });
            });
        }
    }

    onDomainChange(e) {
        this.setState({
            inputDomain: e.target.value,
            inputNiveau: -1,
            educationniveau: null
        });

        if (e.target.value !== -1) {
            getEducationNiveau(globalSns.languageId, e.target.value, (data) => {
                this.setState({
                    educationniveau: data
                });
            });
        }
    }

    onNiveauChange(e) {
        this.setState({
            educationniveau: e.target.value
        });
    }

    onOrganisationChange(e, id) {
            
        this.setState({
            inputOrganisation: e.target.value,
            inputOrganisationId: id
        });
    }

    onDescriptionChange(e, id, synonymId) { 
        this.setState({
            inputDescription: e.target.value,
            inputDescriptionId: id,
            inputDescriptionSynonymId: synonymId
        });
    }

    onDescriptionBlur(e) {
        var popupDomain = (this.state.inputDescription !== "" && this.state.inputDescriptionId == null);
        this.setState({popupDomain: popupDomain});
        if (popupDomain) {
            setTimeout(() => {
                this.refs.inputDomain.el.focus();  
            }, 0);
        } else {
            setTimeout(() => {
                this.refs.inputOrganisation.el.focus();  
            }, 0);
        }
    }

    onForeignDescriptionChange(e) {
        this.setState({
            inputDescription: e.target.value
        })
    }

    onSelectChange(e) {
        this.setState({
            [e.target.id]: parseInt(e.target.value, 10)
        });         
    }    
    
    onHighestChange(e) {
        this.setState({
            [e.target.id]: e.target.checked
        });         
    }    

    render() {
        
        if (this.state.data == null || this.state.personEducations == null || this.state.countries == null || this.state.results == null) {
            return (
                <Loading/>
            );
        }

        var yearGrad = [];
        var yearGradStart = new Date().getFullYear() - 80;
        var yearGradEnd = new Date().getFullYear() + 4;

        for (var iGrad = yearGradStart; iGrad <= yearGradEnd; iGrad++) {
            yearGrad.push({
                key: iGrad,
                value: iGrad
            })
        }

        return (
            <div> 
                <h4 className="legend-title">{getTranslation("sns.webparts.educations.cat")}</h4>

                <p><em>{getTranslation("sns.webparts.educations.sub")}</em></p>

                <FormList values={getEducationsFormList(this.state.personEducations)} title={getTranslation("sns.webparts.educations.selected")} isUserData={true}
                    showEdit={true} showDelete={true} highlightId={this.state.editId} onDelete={this.deleteEducation} onEdit={this.editEducation} />                

                <NamezzzCountry id="inputCountry" text={getTranslation("sns.webparts.jobapply.educations")}
                    languageId={globalSns.languageId} countries={this.state.countries}
                    countryId={this.state.inputCountryId} onCountryChange={this.onCountryChange} />
                {
                    (this.state.inputCountryId === 1) ?
                    <div id="eduBelgium">
                        <NamezzzEdu id="inputEdu" ref="inputEduBelgium" disabled={this.state.inputCountryId == null}
                            text={getTranslation("sns.webparts.educations.description")} 
                            required={true} 
                            showValidation={this.state.showValidation}
                            validationText={isEmpty(this.state.inputDescription) ? getTranslation("basicform.erroremptyvalue"): null}
                            seqlang={globalSns.languageId}
                            value={this.state.inputDescription} 
                            onChange={this.onDescriptionChange} 
                            onBlur={this.onDescriptionBlur} />
                    </div> :
                    <div id="eduForeign">
                        <FormInput id="inputEdu" ref="inputEduForeign" disabled={this.state.inputCountryId == null} 
                            text={getTranslation("sns.webparts.educations.description")}
                            required={true}
                            showValidation={this.state.showValidation}
                            validationText={isEmpty(this.state.inputDescription) ? getTranslation("basicform.erroremptyvalue"): null}
                            value={this.state.inputDescription} 
                            onChange={this.onForeignDescriptionChange} />
                    </div>
                }
                <div id="domain" className={this.state.popupDomain ? "" : "hidden"}>
                
                    <div className="tr">
                        <div className="FieldLabel td">&nbsp;</div>
                        <div className="EditingFormValueCell td">
                            {getTranslation("sns.webparts.educations.specific")}
                        </div>
                    </div>
                    <FormSelect id="inputDomain" ref="inputDomain" disabled={this.state.inputCountryId == null}
                        text={getTranslation("sns.webparts.educations.domain")}
                        required={true}
                        showValidation={this.state.showValidation}
                        validationText={this.state.inputDomain === -1 ? getTranslation("basicform.erroremptyvalue"): null}
                        emptyValue={getTranslation("sns.general.ddlnovalue")}
                        data={this.state.educationdomain}
                        value={this.state.inputDomain}
                        onChange={this.onDomainChange} />
                    <FormSelect id="inputNiveau" disabled={this.state.inputCountryId == null}
                        text={getTranslation("sns.webparts.educations.niveau")}
                        required={true}
                        showValidation={this.state.showValidation}
                        validationText={this.state.inputNiveau === -1 ? getTranslation("basicform.erroremptyvalue"): null}
                        emptyValue={getTranslation("sns.general.ddlnovalue")}
                        data={this.state.educationniveau}
                        value={this.state.inputNiveau}
                        onChange={this.onSelectChange} />
                
                </div>
                <NamezzzEduOrg id="inputOrganisation" ref="inputOrganisation" disabled={this.state.inputCountryId == null} seqcountry={this.state.inputCountryId}
                    text={getTranslation("sns.webparts.educations.organisation")} 
                    required={true}
                    showValidation={this.state.showValidation}
                    validationText={isEmpty(this.state.inputOrganisation) ? getTranslation("basicform.erroremptyvalue"): null}
                    value={this.state.inputOrganisation} 
                    onChange={this.onOrganisationChange} />
                <FormSelect id="inputYearGrad"
                    text={getTranslation("sns.webparts.educations.yeargrad")}
                    required={true}
                    showValidation={this.state.showValidation}
                    validationText={this.state.inputYearGrad === -1 ? getTranslation("basicform.erroremptyvalue"): null}
                    emptyValue={getTranslation("sns.general.ddlnovalue")}
                    data={yearGrad}
                    value={this.state.inputYearGrad}
                    onChange={this.onSelectChange} />
                <FormSelect id="inputResult"
                    text={getTranslation("sns.webparts.educations.result")}
                    required={true} 
                    showValidation={this.state.showValidation}
                    validationText={this.state.inputResult === -1 ? getTranslation("basicform.erroremptyvalue"): null}
                    emptyValue={getTranslation("sns.general.ddlnovalue")}
                    data={this.state.results}
                    value={this.state.inputResult}
                    onChange={this.onSelectChange} />
                <FormCheckbox id="inputHighest"
                    text={getTranslation("sns.webparts.educations.highest")}
                    value={this.state.inputHighest}
                    onChange={this.onHighestChange} />
                
                <div className="tr text-right col-md-8 button-wrapper">
                    <input type="button" className="FormButton btn btn-primary blue act" value={getTranslation("sns.webparts.educations.reset")} id="actreset" onClick={this.resetEducation} />
                    <input type="button" className="FormButton btn btn-primary blue act" value={getTranslation("sns.webparts.educations." + ((this.state.editId == null) ? "add" : "edit"))} id="actsave" onClick={this.addEducation} />
                </div>
            </div>
        );
    }
}

export default Educations;


// WEBPACK FOOTER //
// ./src/Components/Tabs/Educations.js